import { ApolloQueryResult, OperationVariables } from '@apollo/client';
import { createContext } from 'react';
import { GeoIpLocation, Scalars, User } from 'services/graphqltypes';

export type UserPermissions = {
  communityId: Scalars['UUID'];
  communityName: Scalars['JSON'];
  communitySlug: string;
  role: Scalars['JSON'];
  permissions: string[];
};

export type UserContextValues = {
  loading: boolean;
  isAuthenticated: boolean;
  currentUser: User;
  refetchCurrentUser: (variables?: Partial<OperationVariables>) => Promise<ApolloQueryResult<any>>;
  currentUserPermissions: UserPermissions[];
  currentUserChildren: User[];
  currentUserGeoIPLocation: GeoIpLocation;
};

export const UserContext = createContext<UserContextValues>(null);
